import * as constants from './constants';

export const initialState = {
  loading: false,
  list: {},
  item: {},
  commissions: {},
  error: undefined,
};

const promoCodesReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.RESET_PROMOCODES_ERROR:
    case constants.FETCH_PROMOCODES:
    case constants.FETCH_PROMOCODES_FAIL:
    case constants.FETCH_PROMOCODES_SUCCESS:
    case constants.FETCH_PROMOCODE:
    case constants.FETCH_PROMOCODE_FAIL:
    case constants.FETCH_PROMOCODE_SUCCESS:
    case constants.CREATE_PROMOCODE:
    case constants.CREATE_PROMOCODE_FAIL:
    case constants.CREATE_PROMOCODE_SUCCESS:
    case constants.UPDATE_PROMOCODE:
    case constants.UPDATE_PROMOCODE_FAIL:
    case constants.UPDATE_PROMOCODE_SUCCESS:
    case constants.DELETE_PROMOCODE:
    case constants.DELETE_PROMOCODE_FAIL:
    case constants.DELETE_PROMOCODE_SUCCESS:
    case constants.FETCH_PROMOCODE_COMMISSIONS:
    case constants.FETCH_PROMOCODE_COMMISSIONS_FAIL:
    case constants.FETCH_PROMOCODE_COMMISSIONS_SUCCESS:
    case constants.CREATE_PROMOCODE_COMMISSION:
    case constants.CREATE_PROMOCODE_COMMISSION_FAIL:
    case constants.CREATE_PROMOCODE_COMMISSION_SUCCESS:
    case constants.UPDATE_PROMOCODE_COMMISSION:
    case constants.UPDATE_PROMOCODE_COMMISSION_FAIL:
    case constants.UPDATE_PROMOCODE_COMMISSION_SUCCESS:
    case constants.DELETE_PROMOCODE_COMMISSION:
    case constants.DELETE_PROMOCODE_COMMISSION_FAIL:
    case constants.DELETE_PROMOCODE_COMMISSION_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default promoCodesReducer;
